import { render, staticRenderFns } from "./TagTest.vue?vue&type=template&id=0ca0d8ad&scoped=true"
import script from "./TagTest.vue?vue&type=script&lang=js"
export * from "./TagTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0d8ad",
  null
  
)

export default component.exports